import React, { FC } from 'react';
import { LI_METRICS_PROPERTIES } from 'app/modules/insights/modules/postsPerformance/utils/metricProperty';
import { StandardPostDetailedMetrics } from 'app/types/StandardPostDetailed';
import ValueBox from './ValueBox';
import { getValueBox } from 'app/modules/insights/modules/postsPerformance/utils/getValueBox';
import NumberUtil from 'utils/number';
import { Locales } from 'app/config/locales';

type Props = {
  metrics: StandardPostDetailedMetrics;
};

const selectedProperties = [
  LI_METRICS_PROPERTIES.reactions,
  LI_METRICS_PROPERTIES.comments,
  LI_METRICS_PROPERTIES.shares,
];

const LinkedInValueBoxes: FC<Props> = ({ metrics }) => {
  const valueBoxes = selectedProperties.map((selectedProperty) => {
    const valueBox = getValueBox(
      metrics[selectedProperty.key],
      selectedProperty,
    );
    return {
      ...valueBox,
      value: NumberUtil.format(valueBox.value, {
        notation: 'compact',
        compactDisplay: 'short',
        locales: Locales.EN_US,
      }),
    };
  });

  return (
    <div className="tw-flex tw-flex-wrap">
      {valueBoxes.map((valueBox, index) => (
        <React.Fragment key={`instagram-value-box-${index}`}>
          <div className="tw-flex-1 tw-p-4">
            <ValueBox {...valueBox} />
          </div>
          {index + 1 < valueBoxes.length && (
            <div className="tw-w-[1px] tw-bg-grayscale-20" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default LinkedInValueBoxes;
